import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
//language .json files
import EnglishJsonData from "../../locales/languages/english.json";
import SpanishJsonData from "../../locales/languages/spanish.json";
import FrenchJsonData from "../../locales/languages/french.json";
import ItalianJsonData from "../../locales/languages/italian.json";
import MalayJsonData from "../../locales/languages/malay.json";
import SwedishJsonData from "../../locales/languages/swedish.json";
import PotugueseJsonData from "../../locales/languages/portuguese.json";
import GermanJsonData from "../../locales/languages/german.json";
import FinnishJsonData from "../../locales/languages/finnish.json";
import JapaneseJsonData from "../../locales/languages/japanese.json";
i18n.use(LanguageDetector).init({
    debug: true,
    lng: i18n.language,
    fallbackLng: i18n.language,
    keySeparator: false,
    interpolation: {
        escapeValue: false, // react already safes from xss
    },
    resources: {
        en: {
            translations: EnglishJsonData,
        },
        es: {
            translations: SpanishJsonData,
        },
        fr: {
            translations: FrenchJsonData,
        },
        it: {
            translations: ItalianJsonData,
        },
        ms: {
            translations: MalayJsonData,
        },
        sv: {
            translations: SwedishJsonData,
        },
        pt: {
            translations: PotugueseJsonData,
        },
        de: {
            translations: GermanJsonData,
        },
        fi: {
            translations: FinnishJsonData,
        },
        ja: {
            translations: JapaneseJsonData,
        },
    },
    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",
});
export default i18n;
